/**
 * Google Calendar Authentication Service
 *
 * Handles Google OAuth token management, refresh logic, and authentication state
 * using functional patterns following NotePlan Web service abstraction.
 */

import { googleLogout } from '@react-oauth/google'
import { googleApiClient } from './client'
import type { AccessTokenResponse, GoogleSignOutResponse } from './types'

// ============================================================================
// Authentication Functions
// ============================================================================

/**
 * Sign out from Google account and clear tokens
 * Note: This now removes ALL Google accounts for the user
 * @param userId NotePlan user ID
 * @returns Sign out response
 */
export async function signOut(userId: string): Promise<GoogleSignOutResponse> {
  const response = await googleApiClient.post<GoogleSignOutResponse>(
    'signout.php',
    { userid: userId }
  )

  // Always call googleLogout since all accounts are removed
  googleLogout()

  return response.data
}

/**
 * Get access token for a specific Google account
 * @param userId NotePlan user ID
 * @param accountId Google account ID
 * @returns Access token response
 */
export async function getAccessToken(
  userId: string,
  accountId: string
): Promise<AccessTokenResponse> {
  const response = await googleApiClient.post<AccessTokenResponse>('auth.php', {
    userid: userId,
    account_id: accountId,
  })

  return response.data
}
